import NotFound from 'components/Error/NotFound';
import { isWhitelabelPortal } from 'const/PortalType';

export function RequireWhiteLabelPortalType({ children, shouldBeWhiteLabel = true }) {
  if (isWhitelabelPortal(CONFIG.app.portalType) === shouldBeWhiteLabel) {
    return children;
  }

  return <NotFound />;
}
